import { render, staticRenderFns } from "./CalendarMultiselect.vue?vue&type=template&id=bb078ce4"
import script from "./CalendarMultiselect.vue?vue&type=script&lang=js"
export * from "./CalendarMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports